module.exports = __webpack_public_path__ + "static/media/santanderConsumer.b16d4c0a.png";